// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#004f9f","primaryColorLight":"#055cb4","primaryColorLighter":"#1982ec","primaryColorLightest":"#64a8ee"};